export const AppDomain = 'berko.link'
export const ApiPath = 'api'
export const MediaApiPath = `${ApiPath}/media`
